/**
 * Browse nav boot env — default ON; only literal `'false'` disables.
 * Must stay behavior-identical to `scripts/lib/parseCustomerBrowseNavBootEnv.mjs`
 * (Node postbuild) — locked by `customerFeatureFlags.browseNav.test.ts`.
 */
export function parseCustomerBrowseNavBootEnv(
  value: string | undefined,
): boolean {
  return value !== 'false';
}
